import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import Dashboard from './Dashboard';

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

class NoRedBoxErrorBoundary extends React.Component {
  componentDidCatch(error, info) {
    console.error(error); // Just logs the error
  }

  render() {
    return this.props.children;
  }
}

root.render(
  // <ThemeProvider theme={theme}>
  //   {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
  //   <CssBaseline />
   
    <NoRedBoxErrorBoundary>
      <Dashboard />
  </NoRedBoxErrorBoundary>,
  // </ThemeProvider>,
);
